import { Outlet } from '@tanstack/react-router';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import { AlarmProvider, useAlarmContext } from '_/contexts/AlarmContext';
import { AlarmGroupProvider } from '_/contexts/AlarmGroupContext';
import DocumentTitle from '_/hooks/DocumentTitle';
import React, { ReactElement } from 'react';

function SelectedAlarmContent(): ReactElement {
  const { selectedAlarm, isLoading } = useAlarmContext();

  DocumentTitle(`${selectedAlarm?.name || 'Alarm'} :: ${location.pathname.split('/').pop()}`);

  return (
    <AsyncPageContainer isLoading={isLoading || !selectedAlarm}>
      <Outlet />
    </AsyncPageContainer>
  );
}

function SelectedAlarm(): ReactElement {
  return (
    <AlarmGroupProvider>
      <AlarmProvider>
        <SelectedAlarmContent />
      </AlarmProvider>
    </AlarmGroupProvider>
  );
}

export default SelectedAlarm;
